
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 11"}},[_c('g',{attrs:{"data-name":"Circle Hotspot"}},[_c('path',{attrs:{"d":"M24 48a24 24 0 1124-24 24 24 0 01-24 24","fill":"#11365f"}}),_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2.5"}},[_c('path',{attrs:{"data-name":"Line 4","d":"M24 35V13"}}),_c('path',{attrs:{"data-name":"Line 5","d":"M35 24H13"}})])])])])
          )
        }
      }
    